/** Major version which is no longer supported, to force app update
 *
 *  Version 257 contains native tab navigation removal in preparation for Bet Loop
 */
export const UNSUPPORTED_APP_VERSION = 256

/** Minimum supported Android version, with access to Play Store (minSdkVersion) */
export const MIN_SUPPORTED_ANDROID_OS = 29

/** Minimum supported iOS version, with access to App Store (ios_version specified in podfile) */
export const MIN_SUPPORTED_IOS_OS = 15
